import { render } from "./NahladSuboru.vue?vue&type=template&id=febda440&scoped=true"
import script from "./NahladSuboru.vue?vue&type=script&lang=js"
export * from "./NahladSuboru.vue?vue&type=script&lang=js"

import "./NahladSuboru.vue?vue&type=style&index=0&id=febda440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-febda440"]])

export default __exports__